import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Alert from 'react-bootstrap/Alert';
import PropTypes from 'prop-types';
import { TitleBar, barStyle } from './theme';
import { timeConverter, timeConverterSM } from '../../Utils';

const DateSelectorComp = ({pageState, bsBtnSize}) => {
  const [showPicker, setShowPicker] = useState(false);
  const {dateRange, setDateRange} = pageState;

  const showDatePicker = () =>{
    setShowPicker(true);
  };

  return (
    <div style={{paddingTop:'20px'}}>
        {!showPicker && 
          <Row>        
              <Col xs={bsBtnSize || 2}><Button variant="success" style={{float: 'right'}} onClick={()=>showDatePicker()} > Set Date </Button></Col>
              <Col xs={(12 - bsBtnSize) || 10} style={barStyle}> {timeConverter(dateRange[0])} - {timeConverter(dateRange[1])} </Col>                                                      
          </Row>
        }
        {showPicker && <ChooseDateComp pageState={pageState} pickerState = {{showPicker, setShowPicker}} />}
    </div>
  );
};

const ChooseDateComp = ({pageState, pickerState}) =>{
  const {dateRange, setDateRange} = pageState;
  const [picStartDate, setPicStartDate] = useState(0);
  const [picEndDate, setPicEndDate] = useState(0);

  useEffect(() =>{ 
    // setup a default date range if non exists
    if (picStartDate !==0) return;
    let todayDate = new Date();
    let startDate = new Date();
    startDate.setDate(todayDate.getDate()-7);
    startDate.setHours(0,0,0,0);
    setPicStartDate(timeConverterSM(startDate.getTime()));
  });

  useEffect(() =>{ 
    // setup a default date range if non exists
    if (picEndDate !==0) return;
    let endDate = new Date();
    setPicEndDate(timeConverterSM(endDate.getTime()));
  });
  
  const setDateRangeByDays = (days) => {
    let endDate = new Date();
    let startDate = new Date();
    startDate.setDate(startDate.getDate()-days);
    startDate.setHours(0,0,0,0);

    setDateRange([startDate.getTime(), endDate.getTime()]);
    pageState.deleteThis('getAllTimeMarksForClassByDateRange');
    pageState.deleteThis('getAllTimeMarksForSchoolByDateRange');
    pickerState.setShowPicker(false);
  };
  const selectDateRangeButton = () => {
    let endDate = new Date(picEndDate + 'T00:00');
    let startDate = new Date(picStartDate+ 'T00:00');

    let startDateMilli = startDate.getTime();
    let endDateMilli = endDate.getTime();

    // make sure the start date is less then the end date
    if(endDateMilli < startDateMilli){
      let tmp = endDateMilli;
      endDateMilli = startDateMilli;
      startDateMilli = tmp;
    }

    let totalTime = endDateMilli - startDateMilli;
    let maxTime = 1000*60*60*24*365;

    if(totalTime > maxTime){
      alert('Date Range can not be over 1 year.\n\nIf you would like to view the marks over 1 year then please pull multiple reports by smaller date periods');
      return;
    }

    setDateRange([startDate.getTime(), endDate.getTime()]);
    pageState.deleteThis('getAllTimeMarksForClassByDateRange');
    pageState.deleteThis('getAllTimeMarksForSchoolByDateRange');
    pickerState.setShowPicker(false);
  };

  const hideDatePicker = () =>{
    pickerState.setShowPicker(false);
  };

  return(
    <div style={{borderStyle: 'solid', borderWidth: '1px', borderColor: 'lightgrey', padding:'20px'}}>
      <TitleBar>
        <Col style={{textAlign: 'left', color: 'white' }} xs='8'><h3>Choose a Date Range</h3></Col>
        <Col xs='4'>
            <span className={'pull-right'}>
                <Button variant="danger" onClick={()=>hideDatePicker()}>Cancel</Button> &nbsp;
            </span>
        </Col>
      </TitleBar>
      <br/>
      <Alert variant='danger' >
          <p> To view a summary of marks, either change the start and end dates, then press “Set”, or use the shortcut date buttons.</p>
          <p><strong>Note:</strong> The larger the report, the longer it will take to compile. Reports with large volumes of data can take over 30 seconds. </p>
          {/* <p> <strong>Note:</strong> Selecting date ranges with over 2500 logins will not calculate all the data at this time.  We are working on a fix </p> */}
      </Alert>

      <Row>
          <div style={{paddingTop:'5px'}}>
              <span>&nbsp;Start: <input style={{color: '#000'}} type="date" onChange={(e)=>setPicStartDate(e.target.value)} value={picStartDate} />&nbsp;</span>
              <span>&nbsp;End: <input style={{color: '#000'}} type="date" onChange={(e)=>setPicEndDate(e.target.value)} value={picEndDate} />&nbsp;</span>
              <Button type="button" onClick={()=>selectDateRangeButton()} variant='success'>Set</Button>
          </div>
      </Row>

      <Row>
          &nbsp;<Button style={{marginTop:'8px'}} type="button" onClick={()=>setDateRangeByDays('14')} variant="primary">14 Days</Button>&nbsp;
          <Button style={{marginTop:'8px'}} type="button" onClick={()=>setDateRangeByDays('30')} variant="primary">30 Days</Button>&nbsp;
          <Button style={{marginTop:'8px'}} type="button" onClick={()=>setDateRangeByDays('60')} variant="primary">2 Months</Button>&nbsp;
          <Button style={{marginTop:'8px'}} type="button" onClick={()=>setDateRangeByDays('90')} variant="primary">3 Months</Button>&nbsp;
          <Button style={{marginTop:'8px'}} type="button" onClick={()=>setDateRangeByDays('183')} variant="primary">6 Months</Button>&nbsp;
      </Row>

    </div>
  ); 
};

DateSelectorComp.propTypes = {
  bsBtnSize: PropTypes.number
};

export default DateSelectorComp;